var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ds-app-header"},[_vm._t("left"),_c('div',{staticClass:"ds-title"},[_vm._t("default")],2),_vm._t("right")],2)}
var staticRenderFns = []

export { render, staticRenderFns }